export default __webpack_public_path__ + "static/media/Screenshot (1083).b5d26ad6.png";